<template>
  <div class="main-content">
    <div style="width: 100%;height: 277px; margin: 0;padding: 0;display: flex;justify-content: center;">
      <img
        :src="imageUrl"
        alt="专题专栏图片"
        style="width: 1120px; height: 277px; margin: 0;"
      />
    </div>
    <!-- <div class="nav">
      <div class="nav-box">
        <div
          v-for="item in navItems"
          :key="item.name"
          @click="selectPage(item.name)"
          :class="{ active: item.name === currentPage }"
        >
          {{ item.label }}
        </div>
      </div>
    </div> -->
    <div style="width: 1120px; margin: 0 auto; background-color: #fff"></div>
    <div class="content">
      <component :is="currentPage" ref="currentPageComponent"></component>
    </div>
  </div>
</template>

<script>
import ActiveNews from "./components/ActiveNews.vue";
import BriefingIssue from "./components/BriefingIssue.vue";
import SuperiorSpirit from "./components/SuperiorSpirit.vue";
import Notice from "./components/Notice.vue";
import Information from "./components/Information.vue";
import Model from "./components/Model.vue";
import PartyHistory from "./components/PartyHistory.vue";
import Recommended from "./components/Recommended.vue";
import {imgList} from "@/api/columnZtWindow";
export default {
  data() {
    return {
      navItems: [
        { name: "ActiveNews", label: "活动要闻" },
        { name: "SuperiorSpirit", label: "上级精神" },
        { name: "Notice", label: "机关文件" },
        { name: "Information", label: "信息动态" },
        { name: "BriefingIssue", label: "简报专刊" },
        { name: "Model", label: "典型风采" },
        { name: "PartyHistory", label: "党史资料" },
        { name: "Recommended", label: "推荐阅读" },
      ],
      currentPage: "ActiveNews", // 默认显示 Home 组件
      workId: 4,
      imageUrl: "",
    };
  },
  created() {
    if(this.$route.query.param){
      this.workId = JSON.parse(this.$route.query.param)
      // if(this.workId == 4){
      //   document.title = "支队政工网";
      //   this.winTitle = "支队政工网";
      // }else if(this.workId == 5){
      //   document.title = "灭火救援网";
      //   this.winTitle = "灭火救援网";
      // }else if(this.workId == 6){
      //   document.title = "支队纪委";
      //   this.winTitle = "支队纪委";
      // }else if(this.workId == 7){
      //   document.title = "工会";
      //   this.winTitle = "工会";
      // }
    }
    this.getImgList()
  },
  methods: {
    getImgList(){
      const query = {
        pageNum: 1,
        pageSize: 10
      }
      imgList(query).then(res=>{
        if(res.data.code === 200){
          console.log(res.data.data.list);
          const list  = res.data.data.list
          list.forEach(item=>{
            if(item.id === this.workId){
              this.imageUrl = item.image
              document.title = item.name;
              console.log(item.id,"id",this.workId);
            }
          })
        }
      })
    },
    selectPage(page) {
      this.currentPage = page; // 切换当前页面
      if (page === "ActiveNews" && this.$refs.currentPageComponent.setShow) {
        this.$refs.currentPageComponent.setShow(true);
      }
    },
  },
  components: {
    ActiveNews,
    SuperiorSpirit,
    Notice,
    Information,
    BriefingIssue,
    Model,
    PartyHistory,
    Recommended,
  },
};
</script>

<style scoped lang="scss">
.main-content{
  min-height: 100vh;
  background-color: #F0F5FF;
}
.navbar {
  display: flex;
  background-color: #f8f8f8;
  padding: 10px;
}

.nav {
  width: 100%;
  height: 38px;
  margin: 0 auto;
  background: linear-gradient(to bottom, #144ea0, #165280);

  .nav-box {
    width: 60%;
    height: 38px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 0 auto;

    div {
      width: 92px;
      height: 38px;
      font-weight: bold;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
      text-align: center;
      line-height: 38px;
    }

    .active {
      background-color: #0d4673;
    }
  }
}

.nav-item {
  margin: 0 15px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.nav-item:hover {
  background-color: #e0e0e0;
}
</style>
